import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/image/learningportal.svg';
import { userLoggedOut } from '../features/auth/authSlice';

const Navbar = () => {
  const dispatch=useDispatch()
  const {user} = useSelector((state) => state.auth);
const {pathname}=useLocation()
const navigate=useNavigate();

  return (
    <>
     <nav className="shadow-md">
    <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
      <img className="h-10" src={logo} onClick={()=>navigate(user?.role=='admin' ? '/admin/dashboard' : '/student/courseplayer')} />

      <div className="flex gap-4">

  


      <Link to={'/student/courseplayer'} className={pathname?.includes('courseplayer') ? "px-3 font-bold py-1 border border-cyan rounded-full text-sm bg-cyan text-primary flex items-center" :"px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary flex items-center" } >Course Player</Link>
      <Link to={'/student/leaderboard'} className={pathname?.includes('leaderboard') ? "px-3 font-bold py-1 border border-cyan rounded-full text-sm bg-cyan text-primary flex items-center" :"px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary flex items-center" }>Leaderboard</Link>
        </div>
      <div className="flex items-center gap-3">
        <h2 className="font-medium">{user?.name}</h2>
        <button  onClick={()=>dispatch(userLoggedOut
          ())}  className="flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
          </svg>
          Logout
        </button>
      </div>
    </div>
  </nav>
    </>
  )
}

export default Navbar